export const colors = {
  red: 'red',
  green: 'green',
}
